// Show selected variany
document
  .querySelectorAll('.product-form__controls-group input[type="radio"]')
  .forEach((radio) => {
    radio.addEventListener("change", function () {
      const variantValue = this.getAttribute("aria-label");

      document.getElementById("selected-variant").textContent = variantValue;
    });
  });
